import { css } from '@emotion/react'
import { ExternalStyles, Theme, useTheme } from 'bold-ui'

interface ExemplosHorizontalFieldIndicatorPassouProps {
  style?: ExternalStyles
}

export function ExemplosHorizontalFieldIndicatorPassou(props: Readonly<ExemplosHorizontalFieldIndicatorPassouProps>) {
  const { style } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <svg
      width='162'
      height='32'
      viewBox='0 0 162 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      css={[styles.svg, style]}
    >
      <path d='M162 32H160V16H0V0H2V14H160H162V16V32Z' fill='currentColor' />
    </svg>
  )
}

const createStyles = (theme: Theme) => ({
  svg: css`
    color: ${theme.pallete.primary.c60};
  `,
})
